import type { ReactElement, ReactNode } from "react"
import IconAtm from "@onestore/hel/dist/components/atoms/IconAtm"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import WrapOrg from "@onestore/hel/dist/components/organisms/WrapOrg"
import type Theme from "@onestore/hel/dist/typings/theme"
import Tick from "@onestore-icons/tick.svg"

type ListItemProps = {
  children: ReactNode
  iconColor?: Theme.Color
}

export default function ListItem({
  children,
  iconColor,
}: ListItemProps): ReactElement<ListItemProps> {
  return (
    <WrapOrg gutterSpace={1}>
      <div className="flex items-start gap-2">
        <div className="flex-shrink-0 mt-[0.1875rem]">
          <IconAtm icon={Tick} sizeSpace={2} color={iconColor || "success"} />
        </div>

        <TextAtm typography="small1">{children}</TextAtm>
      </div>
    </WrapOrg>
  )
}
